import { TimezoneCountry } from 'core/types';
import { createContext } from 'react';

export const TimezonesContext = createContext<TimezoneCountry[]>([]);
